import React, { useState, useEffect, useMemo } from "react"
import GridTypeA from "components/grids/GridTypeA/GridTypeA"
import "./PRSSummaryGrid.scss"
import { Tooltip } from "antd"
// Cell Renderers
import PRSUploadStatus from "../ag-grid-cell-renderers/PRSUploadStatus" // TODO: replace with src/components/ag-grid-cell-renderers/PrsUploadStatusCell/PrsUploadStatusCell?
import PRSRecordStatus from "../ag-grid-cell-renderers/PRSRecordStatus"
import PRSErrors from "../ag-grid-cell-renderers/PRSErrors/PRSErrors"
import DocumentsUploadStatus from "components/ag-grid-cell-renderers/DocumentsUploadStatus/DocumentsUploadStatus"

//helper functions
import { getUploadStatus } from "../ag-grid-cell-renderers/PRSUploadStatus"
import { getRecorStatus } from "../ag-grid-cell-renderers/PRSRecordStatus"

var rowHeight = 30

const PRSSummaryGrid = ({ data, hasErrors }) => {
  const [gridApi, setGridApi] = useState(null)
  const [rowData, setRowData] = useState([])

  const gridOptions = useMemo(() => {
    return {
      columnDefs: [
        {
          headerName: "Study ID",
          field: "study_id",
          width: 120,
        },
        {
          headerName: "PRS Upload Status",
          field: "prs_upload_status",
          cellRenderer: PRSUploadStatus,
          valueGetter: ({ data }) => getUploadStatus(data),
          cellRendererParams: {
            parentData: data,
          },
          initialHide: true,
          width: 180,
        },
        {
          headerName: "PRS Record Status",
          field: "ctg_release_status",
          cellRenderer: PRSRecordStatus,
          width: 180,
          cellRendererParams: {
            parentData: data,
          },
          valueGetter: ({ data }) => getRecorStatus(data),
          initialHide: true,
        },
        {
          headerName: "File(s) submitted",
          field: "uploaded_docs",
          cellRenderer: DocumentsUploadStatus,
          flex: 1,
          initialHide: true,
        },
        {
          headerName: "Errors",
          field: "errors",
          cellRenderer: PRSErrors,
          cellRendererParams: {
            parentData: data,
          },
          filterParams: {
            cellRenderer: (params) => {
              return (
                <Tooltip
                  title={params.value}
                  style={{ textOverflow: "ellipsis" }}
                >
                  <span className="upload-summary-filter-ellipsis"> {params.value || "N/A"}</span>
                </Tooltip>
              )
            },
          },
          valueGetter: ({ data: propData }) => {
            if (propData?.upload_report) {
              let uploadStatus = propData.upload_report.uploadStatus
              let recordStatus = propData.upload_report.recordStatus
              let validationMessages = propData.upload_report.validationMessages
              let failureMessage = {
                message: propData.upload_report.failureMessage,
                severity: "ERROR",
                source: "Task Error",
              }

              let messages = []

              if (validationMessages?.validationMessage) {
                messages = Array.isArray(validationMessages.validationMessage)
                  ? validationMessages.validationMessage
                  : [validationMessages.validationMessage]
              }
              if (messages.length > 0 || failureMessage) {
                messages = [failureMessage, ...messages]
                return `Record was not released due to ${messages.length} error(s).`
              } else if (uploadStatus === "ERROR") {
                if (failureMessage) {
                  return failureMessage
                } else {
                  return "Record was not released because the record was not modified in the submission."
                }
              }
            } else if (propData?.upload_failed && data?.task_status?.result) {
              return data?.task_status?.result
            }
          },
          initialHide: true,
          flex: 1,
        },
      ],
      defaultColDef: {
        wrapText: true,
        cellStyle: { whiteSpace: "normal" },
        suppressColumnsToolPanel: true,
        menuTabs: ["filterMenuTab", "generalMenuTab"],
      },

      components: {
        PRSUploadStatus,
        PRSRecordStatus,
        PRSErrors,
      },
    }
  }, [data])

  useEffect(() => {
    if (gridApi) {
      if (hasErrors) {
        gridApi.setColumnsVisible(["errors"], true)
      }
      if (data?.upload_records?.[0]) {
        let firstRecord = data.upload_records[0]
        if (firstRecord.document_upload_status) {
          gridApi.setColumnsVisible(["uploaded_docs"], true)
        }
        if (firstRecord?.upload_report?.uploadStatus || data?.is_cancelled) {
          gridApi.setColumnsVisible(["ctg_release_status"], true)
          gridApi.setColumnsVisible(["prs_upload_status"], true)
        }
      }

      gridApi.sizeColumnsToFit()
    }
  }, [gridApi, hasErrors, data])

  useEffect(() => {
    if (data) {
      setRowData(
        data?.upload_records?.map((record) => {
          let updatedRecord = { ...record }
          if (data.is_cancelled) {
            updatedRecord.is_cancelled = true
          }

          return {
            ...updatedRecord,
          }
        })
      )
    } else {
      setRowData([])
    }
  }, [data])

  const onGridReady = (params) => {
    setGridApi(params.api)
    params.api.sizeColumnsToFit()
  }

  const getRowHeight = (params) => {
    if (rowHeight !== null) {
      return rowHeight
    }
  }

  return (
    <GridTypeA
      onGridReady={onGridReady}
      getRowHeight={getRowHeight}
      gridOptions={gridOptions}
      rowData={rowData}
      defaultColDef={gridOptions.defaultColDef}
      sideBar={false}
    />
  )
}

export default PRSSummaryGrid
